/*!
 * Animated Text Component - Cycles through different messages with smooth animations
 */

import { useState, useEffect } from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const messages = [
  "AI-POWERED CUSTOMER SUPPORT",
  "AI SELLS FOR YOU AUTOMATICALLY",
  "SMART CUSTOMER SERVICE PLATFORM",
  "ARTIFICIAL INTELLIGENCE THAT CONVERTS",
  "INTELLIGENT SUPPORT, BETTER SALES",
  "AI THAT WORKS 24/7 FOR YOU",
];

function AnimatedText({ 
  variant = "h2", 
  fontWeight = "bold", 
  color = "logo",
  textGradient = true,
  sx = {},
  textAlign = "center",
  ...rest 
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Fade out
      setIsVisible(false);
      
      // After fade out, change text and fade in
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
        setIsVisible(true);
      }, 500); // Half of transition duration
    }, 3000); // Change text every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <VuiBox
      sx={{
        position: "relative",
        minHeight: "80px",
        display: "flex",
        alignItems: "center",
        justifyContent: textAlign === "center" ? "center" : textAlign === "right" ? "flex-end" : "flex-start",
        ...sx,
      }}
    >
      <VuiTypography
        variant={variant}
        fontWeight={fontWeight}
        color={color}
        textGradient={textGradient}
        textAlign={textAlign}
        sx={{
          position: "absolute",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(-20px)",
          transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
          letterSpacing: "4px",
          textShadow: "0 2px 20px rgba(0, 117, 255, 0.3)",
        }}
        {...rest}
      >
        {messages[currentIndex]}
      </VuiTypography>
    </VuiBox>
  );
}

export default AnimatedText;

